// API Endpoints

export const EVENT_KINDS = {
  PUBLISH_STALL: 300170, // 30017 is the real event kind
  PUBLISH_PRODUCT: 300180, // 30018 is the real event kind
};
